/** ব্যবসার কর্মী ও নিজের পাসওয়ার্ড পরিবর্তন (docs/specs/staff.md, B-71)। */
export const staff = {
    title: "কর্মী",
    description: "এই ব্যবসায় যারা কাজ করেন, তারা কী করতে পারেন এবং তাদের অ্যাক্সেস।",
    add: "কর্মী যোগ করুন",
    empty: "আপনি ছাড়া এখনো কেউ নেই। ক্যাশিয়ার ও ম্যানেজার যোগ করুন।",
    everywhere: "সব লোকেশন",
    you: "আপনি",
    disabled: "অ্যাক্সেস বন্ধ",
    mustChange: "প্রথম পাসওয়ার্ড",
    posPin: "POS PIN আছে",
    noPosPin: "POS PIN নেই",
    actions: "{{name}}-এর জন্য কাজ",
    disable: "অ্যাক্সেস বন্ধ করুন",
    enable: "অ্যাক্সেস চালু করুন",
    resetPassword: "পাসওয়ার্ড রিসেট",
    addRole: "রোল যোগ করুন",
    removeRole: "{{role}} সরান",
    disabledOk: "{{name}} আর এই ব্যবসায় সাইন ইন করতে পারবেন না।",
    enabledOk: "{{name}} আবার সাইন ইন করতে পারবেন।",
    roleAdded: "রোল যোগ হয়েছে।",
    roleRemoved: "রোল সরানো হয়েছে।",
    roleNames: {
        owner: "মালিক",
        admin: "অ্যাডমিন",
        branch_manager: "শাখা ম্যানেজার",
        cashier: "ক্যাশিয়ার",
        inventory_staff: "ইনভেন্টরি কর্মী",
        order_staff: "অর্ডার কর্মী",
        accountant: "হিসাবরক্ষক",
    },
    form: {
        title: "কর্মী যোগ করুন",
        description: "তারা এই মোবাইল নম্বর বা ই-মেইল আর আপনার দেওয়া প্রথম পাসওয়ার্ড দিয়ে সাইন ইন করবেন, তারপর নিজের পাসওয়ার্ড দেবেন।",
        name: "নাম",
        phone: "মোবাইল নম্বর",
        email: "ই-মেইল (মোবাইল নম্বর দিলে ঐচ্ছিক)",
        password: "প্রথম পাসওয়ার্ড",
        passwordHint: "কমপক্ষে ৮ অক্ষর। সরাসরি তাকে দিন; প্রথম সাইন-ইনে তিনি এটি বদলাবেন।",
        generate: "তৈরি করুন",
        copy: "কপি",
        copied: "কপি হয়েছে।",
        role: "রোল",
        location: "কোথায়",
        submit: "যোগ করুন",
        cancel: "বাতিল",
    },
    added: {
        title: "{{name}} যোগ হয়েছেন",
        body: "তাকে এই তথ্য দিন। প্রথম সাইন-ইনে তিনি নিজের পাসওয়ার্ড বেছে নেবেন।",
        signIn: "সাইন ইন করবেন",
        password: "প্রথম পাসওয়ার্ড",
        done: "ঠিক আছে",
    },
    invitations: {
        title: "উত্তরের অপেক্ষায় থাকা আমন্ত্রণ",
        offer: "এই ব্যক্তির আগে থেকেই Sobthik অ্যাকাউন্ট আছে, তাই সিদ্ধান্ত তিনিই নেবেন। একটি আমন্ত্রণ পাঠান: তিনি গ্রহণ করলে যোগ দেবেন, আর নিজের পাসওয়ার্ডই থাকবে।",
        send: "আমন্ত্রণ পাঠান",
        sent: "{{name}}-কে আমন্ত্রণ পাঠানো হয়েছে।",
        expires: "{{date}} পর্যন্ত খোলা",
        revoke: "ফিরিয়ে নিন",
        revoked: "আমন্ত্রণ ফিরিয়ে নেওয়া হয়েছে।",
        page: {
            title: "আপনাকে আমন্ত্রণ জানানো হয়েছে",
            body: "{{invitedBy}} আপনাকে {{business}}-এ {{role}} হিসেবে যোগ দিতে আমন্ত্রণ জানিয়েছেন। আপনি গ্রহণ না করা পর্যন্ত কিছুই বদলাবে না, আর আপনার নিজের পাসওয়ার্ডই থাকবে।",
            accept: "গ্রহণ করে যোগ দিন",
            decline: "না, ধন্যবাদ",
            accepted: "আপনি {{business}}-এ যোগ দিয়েছেন।",
            declined: "আমন্ত্রণ প্রত্যাখ্যান করা হয়েছে।",
            gone: "এই আমন্ত্রণটি আর নেই",
            goneBody: "এর মেয়াদ শেষ হয়ে থাকতে পারে, ফিরিয়ে নেওয়া হতে পারে, অথবা এটি অন্য অ্যাকাউন্টের জন্য। ঠিক অ্যাকাউন্টে সাইন ইন করেছেন কিনা দেখুন।",
            home: "আমার ড্যাশবোর্ডে যান",
        },
    },
    reset: {
        title: "{{name}}-এর পাসওয়ার্ড রিসেট",
        body: "সব জায়গা থেকে তিনি সাইন আউট হবেন এবং পরের সাইন-ইনে নতুন পাসওয়ার্ড দিতে হবে।",
        submit: "পাসওয়ার্ড রিসেট",
        done: "পাসওয়ার্ড রিসেট হয়েছে। {{name}}-কে নতুন প্রথম পাসওয়ার্ড দিন।",
    },
    roleForm: {
        title: "{{name}}-এর জন্য রোল যোগ",
        submit: "রোল যোগ করুন",
    },
};
//# sourceMappingURL=staff.js.map